var {
  VisuallyHidden
} = require("@react-aria/visually-hidden");

var {
  useTable,
  useTableCell,
  useTableColumnHeader,
  useTableHeaderRow,
  useTableRow,
  useTableRowGroup,
  useTableSelectAllCheckbox,
  useTableSelectionCheckbox
} = require("@react-aria/table");

var {
  useProvider,
  useProviderProps
} = require("@react-spectrum/provider");

var {
  useLocale,
  useMessageFormatter
} = require("@react-aria/i18n");

var {
  useHover,
  usePress
} = require("@react-aria/interactions");

var {
  Tooltip,
  TooltipTrigger
} = require("@react-spectrum/tooltip");

var {
  TableLayout
} = require("@react-stately/layout");

var {
  useVirtualizerState
} = require("@react-stately/virtualizer");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  useCallback,
  useContext,
  useMemo,
  useRef
} = _react2;

var {
  ProgressCircle
} = require("@react-spectrum/progress");

var {
  mergeProps,
  useLayoutEffect
} = require("@react-aria/utils");

var {
  layoutInfoToStyle,
  ScrollView,
  setScrollLeft,
  useVirtualizer,
  VirtualizerItem
} = require("@react-aria/virtualizer");

var {
  FocusRing,
  useFocusRing
} = require("@react-aria/focus");

var {
  classNames,
  useDOMRef,
  useStyleProps
} = require("@react-spectrum/utils");

var {
  Checkbox
} = require("@react-spectrum/checkbox");

var _spectrumIconsUiArrowDownSmall = $parcel$interopDefault(require("@spectrum-icons/ui/ArrowDownSmall"));

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var {
  Column: _Column,
  TableHeader,
  TableBody,
  Section,
  Row,
  Cell,
  useTableState
} = require("@react-stately/table");

exports.Cell = Cell;
exports.Row = Row;
exports.Section = Section;
exports.TableBody = TableBody;
exports.TableHeader = TableHeader;

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/table/vars.css
var $b4e2a47fbd262f6cc963e1dd4b344e5$exports = {};
$b4e2a47fbd262f6cc963e1dd4b344e5$exports = {
  "spectrum-Table": "_spectrum-Table_60175",
  "spectrum-Table-sortedIcon": "_spectrum-Table-sortedIcon_60175",
  "spectrum-Table-headWrapper": "_spectrum-Table-headWrapper_60175",
  "spectrum-Table-headCell": "_spectrum-Table-headCell_60175",
  "is-sortable": "_is-sortable_60175",
  "is-sorted-asc": "_is-sorted-asc_60175",
  "is-sorted-desc": "_is-sorted-desc_60175",
  "spectrum-Table-cell--alignCenter": "_spectrum-Table-cell--alignCenter_60175",
  "spectrum-Table-cell--alignEnd": "_spectrum-Table-cell--alignEnd_60175",
  "spectrum-Table-body": "_spectrum-Table-body_60175",
  "is-drop-target": "_is-drop-target_60175",
  "spectrum-Table-row": "_spectrum-Table-row_60175",
  "spectrum-Table--quiet": "_spectrum-Table--quiet_60175",
  "spectrum-Table-cell": "_spectrum-Table-cell_60175",
  "spectrum-Table--compact": "_spectrum-Table--compact_60175",
  "spectrum-Table--spacious": "_spectrum-Table--spacious_60175",
  "spectrum-Table-cellContents": "_spectrum-Table-cellContents_60175",
  "spectrum-Table-cell--hideHeader": "_spectrum-Table-cell--hideHeader_60175",
  "spectrum-Table--wrap": "_spectrum-Table--wrap_60175",
  "focus-ring": "_focus-ring_60175",
  "is-focused": "_is-focused_60175",
  "spectrum-Table-cell--divider": "_spectrum-Table-cell--divider_60175",
  "spectrum-Table-checkboxCell": "_spectrum-Table-checkboxCell_60175",
  "spectrum-Table-checkbox": "_spectrum-Table-checkbox_60175",
  "is-hovered": "_is-hovered_60175",
  "spectrum-Table-cellWrapper": "_spectrum-Table-cellWrapper_60175",
  "is-active": "_is-active_60175",
  "is-disabled": "_is-disabled_60175",
  "is-selected": "_is-selected_60175"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/src/table.css
var $ae2f840b14db7ad6b343b6404c2$exports = {};
$ae2f840b14db7ad6b343b6404c2$exports = {
  "react-spectrum-Table": "_react-spectrum-Table_16293",
  "react-spectrum-Table-cell": "_react-spectrum-Table-cell_16293",
  "react-spectrum-Table-cellWrapper": "_react-spectrum-Table-cellWrapper_16293",
  "react-spectrum-Table-cell--alignStart": "_react-spectrum-Table-cell--alignStart_16293",
  "react-spectrum-Table-cell--alignCenter": "_react-spectrum-Table-cell--alignCenter_16293",
  "react-spectrum-Table-cell--alignEnd": "_react-spectrum-Table-cell--alignEnd_16293",
  "react-spectrum-Table-centeredWrapper": "_react-spectrum-Table-centeredWrapper_16293"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ar-AE.json
var $bf1cf2456dc68629f291a1e9faa8768c$exports = {};
$bf1cf2456dc68629f291a1e9faa8768c$exports = JSON.parse("{\"loading\":\"جارٍ التحميل...\",\"loadingMore\":\"جارٍ تحميل المزيد...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/bg-BG.json
var $c5cb387521f2613a76e80d8bca4aaded$exports = {};
$c5cb387521f2613a76e80d8bca4aaded$exports = JSON.parse("{\"loading\":\"Зареждане...\",\"loadingMore\":\"Зареждане на още...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/cs-CZ.json
var $ea66ab754160f9d841789cfc6f39a$exports = {};
$ea66ab754160f9d841789cfc6f39a$exports = JSON.parse("{\"loading\":\"Načítání...\",\"loadingMore\":\"Načítání dalších...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/da-DK.json
var $b0721857905db4bb0a5dd1818da44b36$exports = {};
$b0721857905db4bb0a5dd1818da44b36$exports = JSON.parse("{\"loading\":\"Indlæser ...\",\"loadingMore\":\"Indlæser flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/de-DE.json
var $ac384773eadfb2a97a0e4cfddda889e$exports = {};
$ac384773eadfb2a97a0e4cfddda889e$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Mehr laden ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/el-GR.json
var $f13b5979d83b6b7fe850e77c9c9a08$exports = {};
$f13b5979d83b6b7fe850e77c9c9a08$exports = JSON.parse("{\"loading\":\"Φόρτωση...\",\"loadingMore\":\"Φόρτωση περισσότερων...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/en-US.json
var $d3146e8165f181d6f0817c18e52a2e$exports = {};
$d3146e8165f181d6f0817c18e52a2e$exports = JSON.parse("{\"loading\":\"Loading…\",\"loadingMore\":\"Loading more…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/es-ES.json
var $e0360f0f105276f51d4455a733c7fb89$exports = {};
$e0360f0f105276f51d4455a733c7fb89$exports = JSON.parse("{\"loading\":\"Cargando…\",\"loadingMore\":\"Cargando más…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/et-EE.json
var $dc4ee81c3e5b53351ab0e4c9088efea$exports = {};
$dc4ee81c3e5b53351ab0e4c9088efea$exports = JSON.parse("{\"loading\":\"Laadimine...\",\"loadingMore\":\"Laadi rohkem...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/fi-FI.json
var $c606fd3837da5861242f57d42680c9$exports = {};
$c606fd3837da5861242f57d42680c9$exports = JSON.parse("{\"loading\":\"Ladataan…\",\"loadingMore\":\"Ladataan lisää…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/fr-FR.json
var $e61123c82206511a990c7e6cd8a4156$exports = {};
$e61123c82206511a990c7e6cd8a4156$exports = JSON.parse("{\"loading\":\"Chargement...\",\"loadingMore\":\"Chargement supplémentaire...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/he-IL.json
var $afb275db16dfeed38c5d71b1fe494$exports = {};
$afb275db16dfeed38c5d71b1fe494$exports = JSON.parse("{\"loading\":\"טוען...\",\"loadingMore\":\"טוען עוד...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/hr-HR.json
var $f9d9cbed02447de889151bacfed2f701$exports = {};
$f9d9cbed02447de889151bacfed2f701$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/hu-HU.json
var $a6f552321a109c4a3af86db4b422b3$exports = {};
$a6f552321a109c4a3af86db4b422b3$exports = JSON.parse("{\"loading\":\"Betöltés folyamatban…\",\"loadingMore\":\"Továbbiak betöltése folyamatban…\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/it-IT.json
var $ab6c4e247053b5e213eed2db90a8965$exports = {};
$ab6c4e247053b5e213eed2db90a8965$exports = JSON.parse("{\"loading\":\"Caricamento...\",\"loadingMore\":\"Caricamento altri...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ja-JP.json
var $ebd7f508a7cecd6190fbc07bc9947e88$exports = {};
$ebd7f508a7cecd6190fbc07bc9947e88$exports = JSON.parse("{\"loading\":\"読み込み中...\",\"loadingMore\":\"さらに読み込み中...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ko-KR.json
var $ec9f58dc2eaee9b794b7b90de05$exports = {};
$ec9f58dc2eaee9b794b7b90de05$exports = JSON.parse("{\"loading\":\"로드 중\",\"loadingMore\":\"추가 로드 중\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/lt-LT.json
var $ea572c75c23ee6a36aefd90534a1a320$exports = {};
$ea572c75c23ee6a36aefd90534a1a320$exports = JSON.parse("{\"loading\":\"Įkeliama...\",\"loadingMore\":\"Įkeliama daugiau...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/lv-LV.json
var $c1c949b1e6d61f345fa58c0e8f33620$exports = {};
$c1c949b1e6d61f345fa58c0e8f33620$exports = JSON.parse("{\"loading\":\"Notiek ielāde...\",\"loadingMore\":\"Tiek ielādēts vēl...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/nb-NO.json
var $e08e1550e04b2ee8f82580b3561ce011$exports = {};
$e08e1550e04b2ee8f82580b3561ce011$exports = JSON.parse("{\"loading\":\"Laster inn ...\",\"loadingMore\":\"Laster inn flere ...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/nl-NL.json
var $df25bef5bee818e0137ca39a9798d87$exports = {};
$df25bef5bee818e0137ca39a9798d87$exports = JSON.parse("{\"loading\":\"Laden...\",\"loadingMore\":\"Meer laden...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/pl-PL.json
var $f21a28b52c1e55f2f44b00c330f$exports = {};
$f21a28b52c1e55f2f44b00c330f$exports = JSON.parse("{\"loading\":\"Ładowanie...\",\"loadingMore\":\"Wczytywanie większej liczby...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/pt-BR.json
var $bd280eb4069a14c185f011a48f901fe8$exports = {};
$bd280eb4069a14c185f011a48f901fe8$exports = JSON.parse("{\"loading\":\"Carregando...\",\"loadingMore\":\"Carregando mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/pt-PT.json
var $afb5079d0644a21355f347a366cb40$exports = {};
$afb5079d0644a21355f347a366cb40$exports = JSON.parse("{\"loading\":\"A carregar...\",\"loadingMore\":\"A carregar mais...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ro-RO.json
var $d291fcb4b5b743fad4dd59bb68355c$exports = {};
$d291fcb4b5b743fad4dd59bb68355c$exports = JSON.parse("{\"loading\":\"Se încarcă...\",\"loadingMore\":\"Se încarcă mai multe...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/ru-RU.json
var $c0a942a2e02dba68bc15eb74be82c293$exports = {};
$c0a942a2e02dba68bc15eb74be82c293$exports = JSON.parse("{\"loading\":\"Загрузка...\",\"loadingMore\":\"Дополнительная загрузка...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sk-SK.json
var $d413a52944a5e7bfda0ab7005fb6$exports = {};
$d413a52944a5e7bfda0ab7005fb6$exports = JSON.parse("{\"loading\":\"Načítava sa...\",\"loadingMore\":\"Načítava sa viac...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sl-SI.json
var $b99d45011da41e19a12994d8ee2ac36$exports = {};
$b99d45011da41e19a12994d8ee2ac36$exports = JSON.parse("{\"loading\":\"Nalaganje...\",\"loadingMore\":\"Nalaganje več vsebine...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sr-SP.json
var $b5e1841dcff5e532763a9cc86ff6bb8$exports = {};
$b5e1841dcff5e532763a9cc86ff6bb8$exports = JSON.parse("{\"loading\":\"Učitavam...\",\"loadingMore\":\"Učitavam još...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/sv-SE.json
var $c682d1cfd8bd976b405d1e98f26e1d$exports = {};
$c682d1cfd8bd976b405d1e98f26e1d$exports = JSON.parse("{\"loading\":\"Läser in...\",\"loadingMore\":\"Läser in mer...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/tr-TR.json
var $d6797699b1d0b18e1403755652ee2373$exports = {};
$d6797699b1d0b18e1403755652ee2373$exports = JSON.parse("{\"loading\":\"Yükleniyor...\",\"loadingMore\":\"Daha fazla yükleniyor...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/uk-UA.json
var $ebf60898dc7d1b49fdd13ce586ec076f$exports = {};
$ebf60898dc7d1b49fdd13ce586ec076f$exports = JSON.parse("{\"loading\":\"Завантаження…\",\"loadingMore\":\"Завантаження інших об’єктів...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/zh-CN.json
var $e74e1ecc58af10b23f228f4a8a0b$exports = {};
$e74e1ecc58af10b23f228f4a8a0b$exports = JSON.parse("{\"loading\":\"正在加载...\",\"loadingMore\":\"正在加载更多...\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-spectrum/table/intl/zh-TW.json
var $fc6f6e4067779c9919e8502de2564029$exports = {};
$fc6f6e4067779c9919e8502de2564029$exports = JSON.parse("{\"loading\":\"正在載入\",\"loadingMore\":\"正在載入更多…\"}");
// @ts-ignore
const $bb999dd7c3f59a309c892832be501d45$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($bf1cf2456dc68629f291a1e9faa8768c$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($c5cb387521f2613a76e80d8bca4aaded$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($ea66ab754160f9d841789cfc6f39a$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($b0721857905db4bb0a5dd1818da44b36$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($ac384773eadfb2a97a0e4cfddda889e$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($f13b5979d83b6b7fe850e77c9c9a08$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($d3146e8165f181d6f0817c18e52a2e$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($e0360f0f105276f51d4455a733c7fb89$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($dc4ee81c3e5b53351ab0e4c9088efea$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($c606fd3837da5861242f57d42680c9$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($e61123c82206511a990c7e6cd8a4156$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($afb275db16dfeed38c5d71b1fe494$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($f9d9cbed02447de889151bacfed2f701$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($a6f552321a109c4a3af86db4b422b3$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($ab6c4e247053b5e213eed2db90a8965$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($ebd7f508a7cecd6190fbc07bc9947e88$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($ec9f58dc2eaee9b794b7b90de05$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($ea572c75c23ee6a36aefd90534a1a320$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($c1c949b1e6d61f345fa58c0e8f33620$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($e08e1550e04b2ee8f82580b3561ce011$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($df25bef5bee818e0137ca39a9798d87$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($f21a28b52c1e55f2f44b00c330f$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($bd280eb4069a14c185f011a48f901fe8$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($afb5079d0644a21355f347a366cb40$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($d291fcb4b5b743fad4dd59bb68355c$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($c0a942a2e02dba68bc15eb74be82c293$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($d413a52944a5e7bfda0ab7005fb6$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($b99d45011da41e19a12994d8ee2ac36$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($b5e1841dcff5e532763a9cc86ff6bb8$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($c682d1cfd8bd976b405d1e98f26e1d$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($d6797699b1d0b18e1403755652ee2373$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($ebf60898dc7d1b49fdd13ce586ec076f$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($e74e1ecc58af10b23f228f4a8a0b$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($fc6f6e4067779c9919e8502de2564029$exports).default
};
const $bb999dd7c3f59a309c892832be501d45$var$DEFAULT_HEADER_HEIGHT = {
  medium: 34,
  large: 40
};
const $bb999dd7c3f59a309c892832be501d45$var$DEFAULT_HIDE_HEADER_CELL_WIDTH = {
  medium: 36,
  large: 44
};
const $bb999dd7c3f59a309c892832be501d45$var$ROW_HEIGHTS = {
  compact: {
    medium: 32,
    large: 40
  },
  regular: {
    medium: 40,
    large: 50
  },
  spacious: {
    medium: 48,
    large: 60
  }
};
const $bb999dd7c3f59a309c892832be501d45$var$SELECTION_CELL_DEFAULT_WIDTH = {
  medium: 38,
  large: 48
};

const $bb999dd7c3f59a309c892832be501d45$var$TableContext = /*#__PURE__*/_react.createContext(null);

function $bb999dd7c3f59a309c892832be501d45$var$useTableContext() {
  return useContext($bb999dd7c3f59a309c892832be501d45$var$TableContext);
}

var $b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default = $parcel$interopDefault($b4e2a47fbd262f6cc963e1dd4b344e5$exports);
var $ae2f840b14db7ad6b343b6404c2$$interop$default = $parcel$interopDefault($ae2f840b14db7ad6b343b6404c2$exports);

function $bb999dd7c3f59a309c892832be501d45$var$TableView(props, ref) {
  props = useProviderProps(props);
  let {
    isQuiet
  } = props;
  let {
    styleProps
  } = useStyleProps(props);
  let state = useTableState(_babelRuntimeHelpersExtends({}, props, {
    showSelectionCheckboxes: true
  }));
  let domRef = useDOMRef(ref);
  let formatMessage = useMessageFormatter($bb999dd7c3f59a309c892832be501d45$var$intlMessages);
  let {
    scale
  } = useProvider();
  let density = props.density || 'regular';
  let layout = useMemo(() => new TableLayout({
    // If props.rowHeight is auto, then use estimated heights based on scale, otherwise use fixed heights.
    rowHeight: props.overflowMode === 'wrap' ? null : $bb999dd7c3f59a309c892832be501d45$var$ROW_HEIGHTS[density][scale],
    estimatedRowHeight: props.overflowMode === 'wrap' ? $bb999dd7c3f59a309c892832be501d45$var$ROW_HEIGHTS[density][scale] : null,
    headingHeight: props.overflowMode === 'wrap' ? null : $bb999dd7c3f59a309c892832be501d45$var$DEFAULT_HEADER_HEIGHT[scale],
    estimatedHeadingHeight: props.overflowMode === 'wrap' ? $bb999dd7c3f59a309c892832be501d45$var$DEFAULT_HEADER_HEIGHT[scale] : null,
    getDefaultWidth: (_ref) => {
      let {
        hideHeader,
        isSelectionCell,
        showDivider
      } = _ref;

      if (hideHeader) {
        let width = $bb999dd7c3f59a309c892832be501d45$var$DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
        return showDivider ? width + 1 : width;
      } else if (isSelectionCell) {
        return $bb999dd7c3f59a309c892832be501d45$var$SELECTION_CELL_DEFAULT_WIDTH[scale];
      }
    }
  }), [props.overflowMode, scale, density]);
  let {
    direction
  } = useLocale();
  layout.collection = state.collection;
  let {
    gridProps
  } = useTable(_babelRuntimeHelpersExtends({}, props, {
    isVirtualized: true,
    layout
  }), state, domRef); // This overrides collection view's renderWrapper to support DOM heirarchy.

  let renderWrapper = (parent, reusableView, children, renderChildren) => {
    let style = layoutInfoToStyle(reusableView.layoutInfo, direction, parent && parent.layoutInfo);

    if (style.overflow === 'hidden') {
      style.overflow = 'visible'; // needed to support position: sticky
    }

    if (reusableView.viewType === 'rowgroup') {
      return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableRowGroup, {
        key: reusableView.key,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'header') {
      return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableHeader, {
        key: reusableView.key,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'row') {
      return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableRow, {
        key: reusableView.key,
        item: reusableView.content,
        style: style
      }, renderChildren(children));
    }

    if (reusableView.viewType === 'headerrow') {
      return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableHeaderRow, {
        key: reusableView.key,
        style: style,
        item: reusableView.content
      }, renderChildren(children));
    }

    return /*#__PURE__*/_react.createElement(VirtualizerItem, {
      key: reusableView.key,
      reusableView: reusableView,
      parent: parent,
      className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-cellWrapper', classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, {
        'react-spectrum-Table-cellWrapper': !reusableView.layoutInfo.estimatedSize
      }))
    });
  };

  let renderView = (type, item) => {
    switch (type) {
      case 'header':
      case 'rowgroup':
      case 'section':
      case 'row':
      case 'headerrow':
        return null;

      case 'cell':
        {
          if (item.props.isSelectionCell) {
            return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableCheckboxCell, {
              cell: item
            });
          }

          return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableCell, {
            cell: item
          });
        }

      case 'placeholder':
        // TODO: move to react-aria?
        return /*#__PURE__*/_react.createElement("div", {
          role: "gridcell",
          "aria-colindex": item.index + 1,
          "aria-colspan": item.colspan > 1 ? item.colspan : null
        });

      case 'column':
        if (item.props.isSelectionCell) {
          return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableSelectAllCell, {
            column: item
          });
        }

        if (item.props.hideHeader) {
          return /*#__PURE__*/_react.createElement(TooltipTrigger, {
            placement: "top",
            trigger: "focus"
          }, /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableColumnHeader, {
            column: item
          }), /*#__PURE__*/_react.createElement(Tooltip, {
            placement: "top"
          }, item.rendered));
        }

        return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableColumnHeader, {
          column: item
        });

      case 'loader':
        return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$CenteredWrapper, null, /*#__PURE__*/_react.createElement(ProgressCircle, {
          isIndeterminate: true,
          "aria-label": state.collection.size > 0 ? formatMessage('loadingMore') : formatMessage('loading')
        }));

      case 'empty':
        {
          let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;

          if (emptyState == null) {
            return null;
          }

          return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$CenteredWrapper, null, emptyState);
        }
    }
  };

  return /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableContext.Provider, {
    value: state
  }, /*#__PURE__*/_react.createElement($bb999dd7c3f59a309c892832be501d45$var$TableVirtualizer, _babelRuntimeHelpersExtends({}, gridProps, styleProps, {
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table', "spectrum-Table--" + density, {
      'spectrum-Table--quiet': isQuiet,
      'spectrum-Table--wrap': props.overflowMode === 'wrap'
    }, classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, 'react-spectrum-Table')),
    layout: layout,
    collection: state.collection,
    focusedKey: state.selectionManager.focusedKey,
    renderView: renderView,
    renderWrapper: renderWrapper,
    domRef: domRef
  })));
} // This is a custom Virtualizer that also has a header that syncs its scroll position with the body.


function $bb999dd7c3f59a309c892832be501d45$var$TableVirtualizer(_ref2) {
  var _layout$getLayoutInfo;

  let {
    layout,
    collection,
    focusedKey,
    renderView,
    renderWrapper,
    domRef
  } = _ref2,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref2, ["layout", "collection", "focusedKey", "renderView", "renderWrapper", "domRef"]);

  let {
    direction
  } = useLocale();
  let headerRef = useRef();
  let bodyRef = useRef();
  let loadingState = collection.body.props.loadingState;
  let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
  let onLoadMore = collection.body.props.onLoadMore;
  let state = useVirtualizerState({
    layout,
    collection,
    renderView,
    renderWrapper,

    onVisibleRectChange(rect) {
      bodyRef.current.scrollTop = rect.y;
      setScrollLeft(bodyRef.current, direction, rect.x);
    },

    transitionDuration: isLoading ? 160 : 220
  });
  let {
    virtualizerProps
  } = useVirtualizer({
    focusedKey,

    scrollToItem(key) {
      let item = collection.getItem(key);
      let column = collection.columns[0];
      state.virtualizer.scrollToItem(key, {
        duration: 0,
        // Prevent scrolling to the top when clicking on column headers.
        shouldScrollY: (item == null ? void 0 : item.type) !== 'column',
        // Offset scroll position by width of selection cell
        // (which is sticky and will overlap the cell we're scrolling to).
        offsetX: column.props.isSelectionCell ? layout.columnWidths.get(column.key) : 0
      });
    }

  }, state, domRef);
  let headerHeight = ((_layout$getLayoutInfo = layout.getLayoutInfo('header')) == null ? void 0 : _layout$getLayoutInfo.rect.height) || 0;
  let visibleRect = state.virtualizer.visibleRect; // Sync the scroll position from the table body to the header container.

  let onScroll = useCallback(() => {
    headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
  }, [bodyRef]);
  let onVisibleRectChange = useCallback(rect => {
    state.setVisibleRect(rect);

    if (!isLoading && onLoadMore) {
      let scrollOffset = state.virtualizer.contentSize.height - rect.height * 2;

      if (rect.y > scrollOffset) {
        onLoadMore();
      }
    }
  }, [onLoadMore, isLoading, state.setVisibleRect, state.virtualizer]);
  useLayoutEffect(() => {
    if (!isLoading && onLoadMore && !state.isAnimating) {
      if (state.contentSize.height <= state.virtualizer.visibleRect.height) {
        onLoadMore();
      }
    }
  }, [state.contentSize, state.virtualizer, state.isAnimating, onLoadMore, isLoading]);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, mergeProps(otherProps, virtualizerProps), {
    ref: domRef
  }), /*#__PURE__*/_react.createElement("div", {
    role: "presentation",
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-headWrapper'),
    style: {
      width: visibleRect.width,
      height: headerHeight,
      overflow: 'hidden',
      position: 'relative',
      willChange: state.isScrolling ? 'scroll-position' : '',
      transition: state.isAnimating ? "none " + state.virtualizer.transitionDuration + "ms" : undefined
    },
    ref: headerRef
  }, state.visibleViews[0]), /*#__PURE__*/_react.createElement(ScrollView, {
    role: "presentation",
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-body'),
    style: {
      flex: 1
    },
    innerStyle: {
      overflow: 'visible',
      transition: state.isAnimating ? "none " + state.virtualizer.transitionDuration + "ms" : undefined
    },
    ref: bodyRef,
    contentSize: state.contentSize,
    onVisibleRectChange: onVisibleRectChange,
    onScrollStart: state.startScrolling,
    onScrollEnd: state.endScrolling,
    onScroll: onScroll
  }, state.visibleViews[1]));
}

function $bb999dd7c3f59a309c892832be501d45$var$TableHeader(_ref3) {
  let {
    children
  } = _ref3,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref3, ["children"]);

  let {
    rowGroupProps
  } = useTableRowGroup();
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, rowGroupProps, otherProps, {
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-head')
  }), children);
}

function $bb999dd7c3f59a309c892832be501d45$var$TableColumnHeader(_ref4) {
  var _state$sortDescriptor, _state$sortDescriptor2, _state$sortDescriptor3, _state$sortDescriptor4;

  let {
    column
  } = _ref4;
  let ref = useRef();
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let {
    columnHeaderProps
  } = useTableColumnHeader({
    node: column,
    isVirtualized: true
  }, state, ref);
  let columnProps = column.props;
  let {
    hoverProps,
    isHovered
  } = useHover({});
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, mergeProps(columnHeaderProps, hoverProps), {
    ref: ref,
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-headCell', {
      'is-sortable': columnProps.allowsSorting,
      'is-sorted-desc': ((_state$sortDescriptor = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor.column) === column.key && ((_state$sortDescriptor2 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor2.direction) === 'descending',
      'is-sorted-asc': ((_state$sortDescriptor3 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor3.column) === column.key && ((_state$sortDescriptor4 = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor4.direction) === 'ascending',
      'is-hovered': isHovered,
      'spectrum-Table-cell--hideHeader': columnProps.hideHeader
    }, classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, 'react-spectrum-Table-cell', {
      'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center' || column.colspan > 1,
      'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
    }))
  }), columnProps.hideHeader ? /*#__PURE__*/_react.createElement(VisuallyHidden, null, column.rendered) : column.rendered, columnProps.allowsSorting && /*#__PURE__*/_react.createElement(_spectrumIconsUiArrowDownSmall, {
    UNSAFE_className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-sortedIcon')
  })));
}

function $bb999dd7c3f59a309c892832be501d45$var$TableSelectAllCell(_ref5) {
  let {
    column
  } = _ref5;
  let ref = useRef();
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let isSingleSelectionMode = state.selectionManager.selectionMode === 'single';
  let {
    columnHeaderProps
  } = useTableColumnHeader({
    node: column,
    isVirtualized: true
  }, state, ref);
  let {
    checkboxProps
  } = useTableSelectAllCheckbox(state);
  let {
    hoverProps,
    isHovered
  } = useHover({});
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, mergeProps(columnHeaderProps, hoverProps), {
    ref: ref,
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-headCell', 'spectrum-Table-checkboxCell', {
      'is-hovered': isHovered
    })
  }),
  /*
    In single selection mode, the checkbox will be hidden.
    So to avoid leaving a column header with no accessible content,
    we use a VisuallyHidden component to include the aria-label from the checkbox,
    which for single selection will be "Select."
  */
  isSingleSelectionMode && /*#__PURE__*/_react.createElement(VisuallyHidden, null, checkboxProps['aria-label']), /*#__PURE__*/_react.createElement(Checkbox, _babelRuntimeHelpersExtends({}, checkboxProps, {
    isDisabled: isSingleSelectionMode,
    isEmphasized: true,
    UNSAFE_style: isSingleSelectionMode ? {
      visibility: 'hidden'
    } : undefined,
    UNSAFE_className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-checkbox')
  }))));
}

function $bb999dd7c3f59a309c892832be501d45$var$TableRowGroup(_ref6) {
  let {
    children
  } = _ref6,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref6, ["children"]);

  let {
    rowGroupProps
  } = useTableRowGroup();
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, rowGroupProps, otherProps), children);
}

function $bb999dd7c3f59a309c892832be501d45$var$TableRow(_ref7) {
  let {
    item,
    children
  } = _ref7,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(_ref7, ["item", "children"]);

  let ref = useRef();
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let allowsSelection = state.selectionManager.selectionMode !== 'none';
  let isDisabled = state.disabledKeys.has(item.key);
  let isSelected = state.selectionManager.isSelected(item.key);
  let {
    rowProps
  } = useTableRow({
    node: item,
    isVirtualized: true
  }, state, ref);
  let {
    pressProps,
    isPressed
  } = usePress({
    isDisabled
  }); // The row should show the focus background style when any cell inside it is focused.
  // If the row itself is focused, then it should have a blue focus indicator on the left.

  let {
    isFocusVisible: isFocusVisibleWithin,
    focusProps: focusWithinProps
  } = useFocusRing({
    within: true
  });
  let {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let props = mergeProps(rowProps, otherProps, focusWithinProps, focusProps, hoverProps, allowsSelection && pressProps);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, props, {
    ref: ref,
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-row', {
      'is-active': isPressed,
      'is-selected': isSelected,
      'is-focused': isFocusVisibleWithin,
      'focus-ring': isFocusVisible,
      'is-hovered': isHovered && allowsSelection,
      'is-disabled': isDisabled
    })
  }), children);
}

function $bb999dd7c3f59a309c892832be501d45$var$TableHeaderRow(_ref8) {
  let {
    item,
    children,
    style
  } = _ref8;
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let ref = useRef();
  let {
    rowProps
  } = useTableHeaderRow({
    node: item,
    isVirtualized: true
  }, state, ref);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, rowProps, {
    ref: ref,
    style: style
  }), children);
}

function $bb999dd7c3f59a309c892832be501d45$var$TableCheckboxCell(_ref9) {
  let {
    cell
  } = _ref9;
  let ref = useRef();
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  let {
    gridCellProps
  } = useTableCell({
    node: cell,
    isVirtualized: true
  }, state, ref);
  let {
    checkboxProps
  } = useTableSelectionCheckbox({
    key: cell.parentKey
  }, state);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, gridCellProps, {
    ref: ref,
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-cell', 'spectrum-Table-checkboxCell', {
      'is-disabled': isDisabled
    }, classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, 'react-spectrum-Table-cell'))
  }), state.selectionManager.selectionMode !== 'none' && /*#__PURE__*/_react.createElement(Checkbox, _babelRuntimeHelpersExtends({}, checkboxProps, {
    isEmphasized: true,
    isDisabled: isDisabled,
    UNSAFE_className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-checkbox')
  }))));
}

function $bb999dd7c3f59a309c892832be501d45$var$TableCell(_ref10) {
  let {
    cell
  } = _ref10;
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  let ref = useRef();
  let columnProps = cell.column.props;
  let isDisabled = state.disabledKeys.has(cell.parentKey);
  let {
    gridCellProps
  } = useTableCell({
    node: cell,
    isVirtualized: true
  }, state, ref);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'focus-ring')
  }, /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, gridCellProps, {
    ref: ref,
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-cell', {
      'spectrum-Table-cell--divider': columnProps.showDivider && cell.column.nextKey !== null,
      'spectrum-Table-cell--hideHeader': columnProps.hideHeader,
      'is-disabled': isDisabled
    }, classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, 'react-spectrum-Table-cell', {
      'react-spectrum-Table-cell--alignStart': columnProps.align === 'start',
      'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center',
      'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
    }))
  }), /*#__PURE__*/_react.createElement("span", {
    className: classNames($b4e2a47fbd262f6cc963e1dd4b344e5$$interop$default, 'spectrum-Table-cellContents')
  }, cell.rendered)));
}

function $bb999dd7c3f59a309c892832be501d45$var$CenteredWrapper(_ref11) {
  let {
    children
  } = _ref11;
  let state = $bb999dd7c3f59a309c892832be501d45$var$useTableContext();
  return /*#__PURE__*/_react.createElement("div", {
    role: "row",
    "aria-rowindex": state.collection.headerRows.length + state.collection.size + 1,
    className: classNames($ae2f840b14db7ad6b343b6404c2$$interop$default, 'react-spectrum-Table-centeredWrapper')
  }, /*#__PURE__*/_react.createElement("div", {
    role: "rowheader",
    "aria-colspan": state.collection.columns.length
  }, children));
}
/**
 * Tables are containers for displaying information. They allow users to quickly scan, sort, compare, and take action on large amounts of data.
 */


const TableView = /*#__PURE__*/_react.forwardRef($bb999dd7c3f59a309c892832be501d45$var$TableView);

exports.TableView = TableView;
// Override TS for Column to support spectrum specific props.
const Column = _Column;
exports.Column = Column;
